
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ProjectsListCard from "@/components/projects/ProjectsListCard.vue";
  import { Project, User } from "@/generated/graphql";
  import CardsContainer from "@/components/card/CardsContainer.vue";
  import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";

  @Component({
    components: {
      ElementsSizeProvider,
      CardsContainer,
      ProjectsListCard,
    },
  })
  export default class ProjectCollection extends Vue {
    @Prop({ type: Array, required: true }) readonly projects!: Project[];
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly hideManager!: boolean;

  }
